import { defineStore } from "pinia";
import { ref } from "vue";

export const useCollapsedStore = defineStore(
	"collapsed",
	() => {
		const collapsed = ref(false);

		const toggle = () => {
			collapsed.value = !collapsed.value;
		};

		return {
			collapsed,
			toggle,
		};
	},
	{
		// 开启数据持久化
		persist: [
			{
				storage: localStorage,
			},
		],
	}
);
